import React, { useState } from "react";
import { Trash2, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";
import { useQueryClient } from "@tanstack/react-query";
import { Button } from "./ui/button";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from "./ui/dialog";

// Pulsante temporaneo: elimina (soft-delete) le buste paga "fantasma" e mostra un report.
export default function PuliziaFantasmaButton() {
  const qc = useQueryClient();
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [running, setRunning] = useState(false);
  const [report, setReport] = useState(null);

  const run = async () => {
    setRunning(true);
    try {
      const { data } = await api.post("/buste_paga/pulizia-fantasma");
      setConfirmOpen(false);
      setReport(data.report || "Operazione completata.");
      toast.success(`Pulizia completata: ${data.eliminate} buste rimosse`);
      qc.invalidateQueries({ queryKey: ["buste_paga"] });
      qc.invalidateQueries({ queryKey: ["buste_paga_mese"] });
      qc.invalidateQueries({ queryKey: ["buste_paga_riepilogo"] });
    } catch {
      toast.error("Errore durante la pulizia");
    } finally {
      setRunning(false);
    }
  };

  return (
    <>
      <Button variant="outline" size="sm" className="text-red-600 border-red-200 hover:bg-red-50"
        onClick={() => setConfirmOpen(true)} data-testid="bp-pulizia-fantasma-btn">
        <Trash2 size={15} className="mr-1.5" /> Pulizia automatica
      </Button>

      <Dialog open={confirmOpen} onOpenChange={setConfirmOpen}>
        <DialogContent data-testid="bp-pulizia-confirm-dialog">
          <DialogHeader>
            <DialogTitle>Pulizia buste fantasma</DialogTitle>
            <DialogDescription>
              Verranno eliminate le buste paga che non corrispondono a nessun operatore attivo nel
              relativo mese (duplicati e record vecchi). L'operazione è reversibile lato database.
              Vuoi procedere?
            </DialogDescription>
          </DialogHeader>
          <DialogFooter>
            <Button variant="ghost" onClick={() => setConfirmOpen(false)} disabled={running} data-testid="bp-pulizia-cancel">Annulla</Button>
            <Button className="bg-red-600 hover:bg-red-700 text-white" onClick={run} disabled={running} data-testid="bp-pulizia-confirm">
              {running ? <><Loader2 size={15} className="mr-1.5 animate-spin" /> Pulizia in corso…</> : "Esegui pulizia"}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      <Dialog open={report !== null} onOpenChange={(o) => !o && setReport(null)}>
        <DialogContent data-testid="bp-pulizia-report-dialog">
          <DialogHeader>
            <DialogTitle>Report pulizia</DialogTitle>
          </DialogHeader>
          <pre className="max-h-80 overflow-auto whitespace-pre-wrap text-sm bg-secondary/40 rounded-lg p-4" data-testid="bp-pulizia-report-text">{report}</pre>
          <DialogFooter>
            <Button onClick={() => setReport(null)} data-testid="bp-pulizia-report-close">Chiudi</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
